const SET_VERSION_WORD = (state, listVersion) => {
  state.listVersion = listVersion;
};

export default {
  SET_VERSION_WORD,
};
